<template>
  <Layout class="landing-page" v-if="isReady" style="padding-top: 128px">
    <div
      class="container"
      v-if="isLandingContentExists"
      style="margin-top: 0px"
    >
      <Row>
        <Col :md="{ span: 14 }" :sm="{ span: 24 }" :xs="{ span: 24 }">
          <!--<div id="addToCalBtn" ref="addToCalBtn"></div>-->
          <div class="landing-content" v-html="landingContent.html"></div>
        </Col>
        <Col
          :md="{ span: 10 }"
          :sm="{ span: 24 }"
          :xs="{ span: 24 }"
          style="padding-left: 32px; padding-right: 32px"
        >
          <Card :bordered="false">
            <register2 style="margin-top: 0px"></register2>
          </Card>
        </Col>
        <!--
      <Col :md="{span:9, offset:1}" :sm="{span:24}" :xs="{span:24}" class="register-area">
        <Button class="big-btn" type="primary" long @click="register">
          <span v-if="isRegRequired">{{ $t("register") }}</span>
          <span v-if="!isRegRequired">{{ $t("join_now") }}</span>
        </Button>
      </Col>
        -->
      </Row>
    </div>
    <div
      class="container"
      style="margin: auto; margin-top: 32px; max-width: 720px"
    >
      <Card v-if="!isLandingContentExists">
        <register2 style="margin-top: 0px"></register2>
      </Card>
    </div>
  </Layout>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Register2 from '@/views/Register2.vue'
import moment from 'moment'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'landing',
  components: {
    Navbar,
    Register2
  },
  data() {
    return {
      webcastId: this.$store.state.webcast.copy._id,
      isReady: false,
      myCalendar: null
    }
  },

  computed: {
    ...mapGetters('webcast', {
      webcast: 'getCopy'
    }),
    ...mapGetters('page-settings', {
      pageSettings: 'getCopy'
    }),

    ...mapGetters('landing-content', {
      getLandingContentFromStore: 'find'
    }),

    landingContent() {
      return this.getLandingContentFromStore({
        query: { webcastId: this.webcastId }
      }).data[0]
    },

    isLandingContentExists() {
      return Boolean(this.landingContent && this.landingContent.html)
    },

    isRegRequired() {
      if (
        this.$store.state['page-settings'].copy.registrationEnabled &&
        !this.registration()
      ) {
        return true
      }
    }
  },

  methods: {
    ...mapActions('landing-content', {
      fetchLandingContentAction: 'find'
    }),
    ...mapGetters('registrations', {
      registration: 'getCopy'
    }),

    register() {
      //console.log(this.isRegRequired);
      if (!this.isRegRequired) {
        if (this.$store.state.stream.ids.length > 1) {
          this.$router.push('stream-select')
        } else {
          if (this.webcast.hasAudioRoom) {
            this.$router.push('webinar')
          } else {
            this.$router.push('live')
          }
        }
      } else {
        this.$router.push('register')
      }
    }
  },

  created() {
    console.log('landing2')
    this.fetchLandingContentAction({
      query: { webcastId: this.webcastId }
    }).then(() => {
      this.isReady = true
    })
  },
  mounted() {}
}
</script>

<style lang="scss">
.landing-content {
  img {
    width: 100% !important;
  }
}
</style>
<style lang="scss" scoped>
.landing-page {
  font-size: 14px;
  img {
    width: 100% !important;
  }
  .container {
    img {
      width: 100% !important;
    }
  }
  ul {
    padding-left: 40px;
  }
}
.form-container {
  ul {
    padding-left: 0px;
  }
}
.event-hero-container {
  position: relative;
  margin-top: 64px;
  text-align: center;
  padding: 36px;
  background-color: #f5f5f5;
  h1 {
    font-size: 32px;
    line-height: 32px;
    font-weight: bold;
    padding: 24px 0px;
  }
}
.event-date {
  font-size: 16px;
}
#addToCalBtn {
  width: 194px;
  margin-top: 16px;
  .add-to-calendar-dropdown {
    text-align: left !important;
    a {
      text-align: left !important;
    }
  }
}

.poweredby_logo {
  background-image: url(/img/powered_by_logo.png);
  background-color: transparent;
  width: 96px;
  height: 66px;
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.2;
  right: 32px;
  float: right;
  position: relative;
  bottom: 0px;
}
.register {
  &-area {
    padding: 40px;
    background-color: #f7f7f7;
  }
}
</style>

<style lang="scss">
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}

*,
::after,
::before {
  box-sizing: border-box;
}
.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive::before {
  display: block;
  content: "";
}

.ql-video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
